<template>
    <footer class="site-footer">
        <div class="container footer">
            <div class="row">   
                <div class="col-md-2">                    
                    <center>
                        <router-link :to="'/'" >
                            <img class="imagenFooterHotel" src='~@/assets/tamboBlanco.png' alt="El Tambo">                                
                        </router-link>
                    </center>                    
                </div>             
                <div class="col-md-2">
                    <center>
                        <h3 class="footer-heading-small text-white">{{$t('Footer["MenuRapido"]["Titulo"]')}}</h3><br>
                        <ul class="list-unstyled"> 
                            <li>
                                <router-link :to="'/'">
                                    {{$t('Footer["MenuRapido"]["link1"]')}}
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="'/Politicas-de-Privacidad'">
                                    {{$t('Footer["TerminosYCondiciones"]')}}
                                </router-link>
                            </li>                          
                            <li>
                                <router-link exact :to="{ name: 'hotel', params: { key: '-Ld4kdUfsXiocoWudFnt' } }">
                                    El Tambo Uno
                                </router-link> 
                            </li>
                            <li>
                                <router-link exact :to="{ name: 'hotel', params: { key: '-Ld4kk5Ev7o_UCdDayty' } }">
                                    El Tambo Dos
                                </router-link> 
                            </li>
                            <li>
                                <router-link exact :to="{ name: 'hotel', params: { key: '-LsgpNGN1Ml4b4UL-Dti' } }">
                                    El Tambo dos de Mayo
                                </router-link> 
                            </li>                                
                        </ul>                                          
                    </center>     
                </div>
                <div class="col-md-2">
                    <center>
                        <h3 class="footer-heading mb-4 text-white">{{$t('Footer["Siguenos"]["Titulo"]')}}:</h3>
                        <p>                            
                            <a title="Facebook" target="_blank" href="https://www.facebook.com/hoteleseltambope" class="pb-2 pr-2 pl-0 ">
                                <span class="icon-facebook socialLinks"></span>
                            </a>
                            <a title="Instagram" target="_blank" href="https://www.instagram.com/hoteleseltamboperu/" class="p-2 ">
                                <span class="icon-instagram socialLinks"></span>
                            </a>
                            <a title="Linkedin" target="_blank" href="https://www.linkedin.com/company/hoteles-el-tambo-per%C3%BA" class="p-2 ">
                                <span class="icon-linkedin socialLinks"></span>
                            </a>
                            <!--<a href="#!" class="p-2"><span class="icon-vimeo"></span></a>-->
                        </p>
                    </center>
                    <center>
                        <h3 class="footer-heading mb-4 text-white">{{$t('Footer["Reclamo"]')}}:</h3>
                        <p>
                            <router-link :to="'/Libro-de-Reclamos'" title="Libro de reclamaciones">
                                {{$t('Footer["libroReclamos"]')}}
                            </router-link>
                        </p>
                    </center>
                </div>             
                <div v-for="(hotelData, index) in hotels" :key="index" class="col-md-2">
                    <center><h5 class="FooterTittle" style="color:white">{{ hotelData.name }}</h5>
                    <p>
                        <font-awesome-icon icon="map-marker-alt" class="text-white"/> 
                        {{ hotelData.direccion }}
                    </p>
                    <p> 
                        <font-awesome-icon icon="phone-alt" class="text-white"/>
                        {{ hotelData.tlffijo }}
                    </p>
                    <p> 
                        <font-awesome-icon icon="phone-alt" class="text-white"/>
                        {{ hotelData.phone }}
                    </p>
                   
                    <p> 
                        <font-awesome-icon icon="envelope" class="text-white"/>
                        {{ hotelData.email }}
                    </p></center>
                </div>                
            </div>
            <div class="row pt-5 mt-5 text-center" style="margin-top:15px !important">
                <div class="col-md-12">
                    <p>
                        Copyright &copy; {{$t('Footer["CopyRight"]')}} | Powered by <strong><a href="https://www.chevere.tech" target="_blank">ChevereTech</a></strong>
                        &copy;
                    </p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
import { db } from '@/firebase.js'

export default {
    name: "MyFooter",
    data () {
      return {        
        hotels: [],
        hotelsOnChildAdded: null,
        hotelsOnChildRemoved: null,
        hotelsRef: db.child("tambohotels")
      }
    },
  methods: {
    async getHotels() {
      this.hotelsOnChildAdded = this.hotelsRef.on("child_added", snapshot => {
          const data = snapshot.val()
          const key = snapshot.key
          data.key = key
          this.hotels.push(data)
      })

      this.hotelsOnChildRemoved = this.hotelsRef.on("child_removed", snapshot => {
          const index = this.hotels.findIndex(e => e.key == snapshot.key)
          this.hotels.splice(index, 1)
      })    
    }        
  },
  created() {
      this.getHotels()
  },
  beforeDestroy() {
      this.hotelsRef.off("child_added", this.hotelsOnChildAdded)
      this.hotelsRef.off("child_removed", this.hotelsOnChildRemoved)
  }
}
</script>

<style scoped>
.socialLinks{
    color:white !important;
    font-size: 20px !important;
}
.footer{
    font-size: 12px !important;
}
.imagenFooterHotel{
    width: 100%
}
.FooterTittle{
    font-size: 14px !important;
}
.footer-heading{
    font-size: 14px !important;
}
@media only screen and (max-width: 750px) {
    .imagenFooterHotel{
        width: 60% ;
    }
}
</style>


// WEBPACK FOOTER //
// MyFooter.vue?0f96f080